module.exports = __webpack_public_path__ + "assets/img/services5.0fd5e520.svg";